import client from './client';

export async function list()       { const { data } = await client.get('/api/companies');        return data; }
export async function get(id)      { const { data } = await client.get(`/api/companies/${id}`);  return data; }
export async function create(body) { const { data } = await client.post('/api/companies', body); return data; }
export async function update(id, body) { const { data } = await client.put(`/api/companies/${id}`, body); return data; }
export async function remove(id)   { const { data } = await client.delete(`/api/companies/${id}`); return data; }
